import React, { useState } from "react";
import $ from "jquery";
import debounce from "lodash/debounce";

import { makeStyles } from "@material-ui/core/styles";
import Fab from "@material-ui/core/Fab";

import Icon from "./Icon";
import arrowUp from "assets/icons/keyboard_arrow_up.svg";

const useStyles = makeStyles({
  toTopButton: {
    position: "fixed",
    bottom: "50px",
    right: "50px",
  },
});

const ScrollTop = () => {
  const classes = useStyles();
  const isScrolledDown = () => window.scrollY > 0;
  const [showButton, setShowButton] = useState(isScrolledDown());

  $(window).scroll(debounce(() => setShowButton(isScrolledDown()), 150));

  const scrollToTop = () => {
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      700
    );
  };

  return showButton ? (
    <Fab
      color="primary"
      aria-label="up"
      onClick={scrollToTop}
      className={classes.toTopButton}
    >
      <Icon src={arrowUp} />
    </Fab>
  ) : null;
};

export default ScrollTop;
